<template>
    <table
        ref="crossTab"
        summary="This table of cross tabulation results has many columns: row level, statistics, a column for each possible response for the column variable, and a total number of responses for each selected variable for the row"
    >
        <colgroup>
            <col span="1" style="width: 15%" />
            <col span="1" style="width: 70%" />
            <col span="1" style="width: 15%" />
        </colgroup>
        <thead>
            <tr>
                <th>
                    <div class="accessibleHide" style="width: 110px">
                        No value
                    </div>
                </th>
                <th style="width: 110px">
                    <div class="accessibleHide">No value</div>
                </th>
                <th
                    :colspan="
                        (columns.length + 1) * reportModel.columnsPerStatistic
                    "
                >
                    <div class="column-title">
                        {{ reportModel.parms.column.variable.variableTitle }}
                    </div>
                </th>
            </tr>
            <tr>
                <th><div class="accessibleHide">No value</div></th>
                <th><div class="accessibleHide">No value</div></th>
                <template v-for="column in columns">
                    <th
                        :colspan="reportModel.columnsPerStatistic"
                        scope="col"
                        align="center"
                        class="column-headings"
                        style="text-align: center"
                        v-bind:key="column.id"
                    >
                        {{ column.title }}
                    </th>
                </template>
                <th
                    :colspan="reportModel.columnsPerStatistic"
                    class="column-headings"
                    scope="col"
                    align="center"
                    style="text-align: center"
                >
                    Total
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td
                    class="row-title-td"
                    :colspan="
                        2 +
                        (columns.length + 1) * reportModel.columnsPerStatistic
                    "
                >
                    <div class="row-title">
                        <b>{{
                            reportModel.parms.row.variable.variableTitle
                        }}</b>
                    </div>
                </td>
            </tr>
            <template v-for="(rowLevel, rowIndex) in levels">
                <crosstab-row
                    ref="theRows"
                    v-for="(
                        statisticDefinition, statisticIndex
                    ) in reportModel.usedStatistics"
                    :key="(rowIndex + 1) * 100 + statisticIndex"
                    :models="models[rowIndex][statisticIndex]"
                    :selectionModel="selectionModel"
                    :reportModel="reportModel"
                    :rowLevel="rowLevel"
                    :statisticDefinition="statisticDefinition"
                    :statisticIndex="statisticIndex"
                    :isControlTotalCombinedYears="isControlTotalCombinedYears"
                    :row="rows[rowIndex]"
                    :columns="columns"
                ></crosstab-row>
            </template>
            <crosstab-row
                ref="rowTotal"
                v-for="(
                    statisticDefinition, statisticIndex
                ) in reportModel.usedStatistics"
                :key="statisticIndex"
                :models="models[models.length - 1][statisticIndex]"
                :selectionModel="selectionModel"
                :reportModel="reportModel"
                :rowLevel="total"
                :statisticDefinition="statisticDefinition"
                :statisticIndex="statisticIndex"
                :isControlTotalCombinedYears="isControlTotalCombinedYears"
                :row="{ id: 0, totalSourceRecords: 1 }"
                :columns="columns"
            ></crosstab-row>
        </tbody>
    </table>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import crosstabRow from '@/components/crossTabulation/report/crosstabRow';
import store from '@/store';

export default {
    props: [
        'control1',
        'control2',
        'reportModel',
        'levels',
        'total',
        'rows',
        'columns',
        'models'
    ],
    computed: {
        selectionModel: function () {
            return current.selectionModel;
        }
    },
    data: function () {
        var vm = this;
        return {
            // levels: $.grep(this.control2.levelsGroupedByRows, function (l) { return l.rowLevel.id !== 0 }),
            // total: $.grep(this.control2.levelsGroupedByRows, function (l) { return l.rowLevel.id === 0 })[0],
            isControlTotalCombinedYears:
                current.modelHelper.isYearTotal(
                    'control1',
                    vm.control1.control1Level
                ) ||
                current.modelHelper.isYearTotal(
                    'control2',
                    vm.control2.control2Level
                )
        };
    },
    components: {
        // <my-component> will only be available in parent's template
        'crosstab-row': crosstabRow
    },
    mounted: function () {
        const vm = this;
        this.$nextTick(function () {
            store.dispatch('loadedControls/mounted', {
                name: 'crosstabTable',
                vm,
                control1: vm.control1,
                control2: vm.control2,
                width: vm.$refs.crossTab.clientWidth,
                table: vm.$refs.crossTab,
                setColumnWidths: vm.setColumnWidths
            });
        });
    },
    methods: {
        setColumnWidths,
        addXlsxCrosstab,
        makeSpacesNonBreaking: function (label) {
            return label.replace(/\s/g, '&nbsp;');
        },
        causeLabelNotToWrap: function (label) {
            //if (label === undefined || label === null) {
            //  debugger
            //}
            var breakingPoint = 18;
            return label.length <= breakingPoint
                ? this.makeSpacesNonBreaking(label)
                : this.makeSpacesNonBreaking(label.substr(0, breakingPoint)) +
                      label.substr(breakingPoint);
            //return label.replace(' ', '&nbsp;');
        }
        // getStatisticLabel: function (statisticDefinition) {
        //   switch (statisticDefinition.apiName) {
        //     case 'sampleSize':
        //       return 'n';
        //     case 'rowPercentage':
        //       return 'Row%';
        //     case 'columnPercentage':
        //       return 'Col%';
        //     case 'totalPercentage':
        //       return '%';
        //     case 'weightedN':
        //       return 'Weighted N';
        //     default:
        //       return statisticDefinition.apiName;
        //   }
        // }
    }
};

function addXlsxCrosstab(p, sheet, def) {
    let vm = this;
    sheet.mergeCellAcrossRows(0, 2);
    sheet.addRow([
        p.theReportModel.parms.row.variable.variableTitle,
        '',
        p.theReportModel.parms.column.variable.variableTitle
    ]);
    sheet.mergeCellAcrossColumns(2, 4);

    var columnHeadings = ['', 'Statistics'];
    sheet.columnWidths.push({ wch: 48.333 });
    sheet.columnWidths.push({ wch: 18.333 });

    p.theReportModel.parms.column.categories.forEach((c) => {
        columnHeadings.push(c.title);
        sheet.columnWidths.push({ wch: 20 });
    });

    columnHeadings.push('Total');
    sheet.columnWidths.push({ wch: 20 });
    sheet.addRow(columnHeadings);

    // def.levelsGroupedByRows.forEach((rowLevel, i) => {
    //   sheet.mergeCellAcrossRows(0, p.theReportModel.totalNumberOfStatistics);
    // });
    vm.$refs.rowTotal.forEach((r) => r.addXlsxRows(sheet));
    vm.$refs.theRows.forEach((r) => r.addXlsxRows(sheet));
}

function setColumnWidths() {
    const vm = this;

    let crosstabRows = vm.$refs.crossTab
        .getElementsByTagName('tbody')[0]
        .getElementsByTagName('tr');

    let cellColumns = getCellColumns(crosstabRows, vm.reportModel);
    cellColumns.forEach((c, i) => clearColumnWidth(c));
    let maxWidths = cellColumns.map((c) => getMaxWidth(c));
    cellColumns.forEach((c, i) => setColumnWidth(c, maxWidths[i]));
}

//Create an array for each statistics column (value, confidence interval or standard error), so it is easy to parse
function getCellColumns(crosstabRows, reportModel) {
    let columns = [];
    for (let i = 0; i < reportModel.columnsPerStatistic; ++i) {
        columns.push([]); //Add an array for the cells
    }

    for (let r of crosstabRows) {
        let tds = r.getElementsByTagName('td');
        for (let i = 2; i < tds.length; ++i) {
            let td = tds[i];
            let column = i % reportModel.columnsPerStatistic;
            columns[column].push(td);
        }
    }
    return columns;
}

function getMaxWidth(tds) {
    let maxWidth = tds.reduce(
        (maxWidth, td) =>
            td.offsetWidth > maxWidth ? td.offsetWidth : maxWidth,
        0
    );
    // let total = tds.reduce((maxWidth, td) => td.offsetWidth > maxWidth ? td.offsetWidth : maxWidth, 0);
    // let average = total / maxWidth;
    // if (
    return maxWidth;
}

function clearColumnWidth(tds, maxWidth) {
    tds.forEach((td) => {
        td.style.minWidth = '1px';
    });
}
function setColumnWidth(tds, maxWidth) {
    tds.forEach((td) => {
        const adjustment = (maxWidth - td.offsetWidth) / td.offsetWidth;
    });
}
</script>

<style scoped>
table {
    /*position: relative;*/
    /*table-layout: fixed;
    width: 100%;*/
    /* width:min-content; */
    width: 1px;
}

/* table td {
      overflow: hidden;
    } */
th {
    width: 1%;
    min-width: 110px;
}
/* tr, th:nth-child(+3) {
      width: 110px;
    } */
td {
    min-width: 110px;
    white-space: nowrap;
}

table tbody tr:first-child td:first-child {
    white-space: normal;
}

table tbody tr:last-child td {
    border: none;
}

table td.statistic-total {
    text-align: center;
}
/*table td.nth-child(2) {
      white-space: nowrap;
    }*/

table td.statistic-cell {
    /*white-space: nowrap;*/
}

.statistic-label {
    padding: 0px 10px 0px 10px;
    /*white-space: nowrap;*/
}

table tr.first-row td:nth-child(2) {
    /*border-left: 2px solid;*/
}

table tr:not(.total-group) td.statistic-value {
    border-left: 2px solid;
}

td.statistic-value {
    padding-left: 10px;
}

table tr.first-row td.statistic-cell {
    border-top: 2px solid;
}

table {
    padding-top: 15px;
    /*margin-left: 50px;*/
}

table tr.first-row td {
    padding-top: 4px;
}

table tr.first-row td {
    padding-top: 15px;
}

table tr.last-row td {
    padding-bottom: 15px;
}

div.column-title {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}
.column-headings {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
}

td.row-title-td {
    background-color: #c1d5b0;
}

div.row-title {
    width: fit-content;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

.row-heading {
    width: fit-content;
    background-color: #c1d5b0;
    padding: 5px 10px 5px 10px;
}
</style>
